module.exports = __webpack_public_path__ + "static/img/gift-box-reward-top.adbcac6.png";